<div class="tab-container" [ngClass]="{'tab-container--disabled': disabled}">
  <div #tabs class="tabs overflow-right">
    <button class="tab tab--0" [ngClass]="{'tab--active': currentSlide === 0}" (click)="updateSlide(0)">
      Total Compensation
    </button>
    <button class="tab tab--1" [ngClass]="{'tab--active': currentSlide === 1}" (click)="updateSlide(1)">
      <lib-icon name="lock"></lib-icon> Signing Bonus
    </button>
    <button class="tab tab--2" [ngClass]="{'tab--active': currentSlide === 2}" (click)="updateSlide(2)">
      <lib-icon name="lock"></lib-icon> Bonus Rate and Bonus Threshold
    </button>
    <button class="tab tab--3" [ngClass]="{'tab--active': currentSlide === 3}" (click)="updateSlide(3)">
      <lib-icon name="lock"></lib-icon> Relocation Bonus
    </button>
    <button class="tab tab--4" [ngClass]="{'tab--active': currentSlide === 4}" (click)="updateSlide(4)">
      <lib-icon name="lock"></lib-icon> Tail Coverage
    </button>
    <button class="tab tab--5" [ngClass]="{'tab--active': currentSlide === 5}" (click)="updateSlide(5)">
      <lib-icon name="lock"></lib-icon> Non-Compete Time Period and Distance
    </button>
    <button class="tab tab--6" [ngClass]="{'tab--active': currentSlide === 6}" (click)="updateSlide(6)">
      <lib-icon name="lock"></lib-icon> Paid Time Off
    </button>
    <button class="tab tab--7" [ngClass]="{'tab--active': currentSlide === 7}" (click)="updateSlide(7)">
      <lib-icon name="lock"></lib-icon> Continuing Medical Education Time and Allowance
    </button>
  </div>

  <lib-carousel
    [currentSlide]="currentSlide"
    [maxSlidesPerView]="1"
    [showPagination]="true"
    (slideChange)="updateSlide($event)"
  >
    <lib-scorecard-section class="slide" *libCarouselItem heading="Total Compensation" tooltip="The amount reported as direct compensation on a W2, 1099, or K1, including bonus payments. It does not include fringe benefits such as health insurance or retirement contributions made by an employer." >
      <lib-scorecard-field [trackingIdPrefix]="trackingIdPrefix" trackingIdPostfix="Rating" prefix="$" name="baseSalary"
        labelText="Enter your total compensation:" [maxLength]="6" (submitEvent)="calculate($event)">
      </lib-scorecard-field>
      <lib-alert-message *ngIf="errors.has('baseSalary')" type="danger">{{ errors.get('baseSalary') }}</lib-alert-message>
      <lib-alert-message *ngIf="errors.has('baseSalaryDataError')" type="danger">
        <ng-content select="[data-slide-error='Base Salary']"></ng-content>
      </lib-alert-message>
      <lib-scorecard-rating *ngIf="ratings.has('baseSalary')" [rating]="ratings.get('baseSalary')"></lib-scorecard-rating>
    </lib-scorecard-section>

    <lib-scorecard-section class="slide" *libCarouselItem heading="Signing Bonus" tooltip="Signing bonus should include any bonus amount paid on execution of the contract, or upon starting
        employment, this does not include relocation allowances.">
      <lib-scorecard-field [trackingIdPrefix]="trackingIdPrefix" trackingIdPostfix="Rating" prefix="$" name="signingBonus"
        labelText="Enter your signing bonus:" [maxLength]="6" (submitEvent)="calculate($event)">
      </lib-scorecard-field>
      <lib-alert *ngIf="errors.has('signingBonus')" [centerContent]="true" [show]="true" [dismissible]="false" type="warning">
        <ng-content select="[data-slide-error='Signing Bonus']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('signingBonus')" [rating]="ratings.get('signingBonus')"></lib-scorecard-rating>
    </lib-scorecard-section>

    <lib-scorecard-section class="slide" *libCarouselItem heading="Bonus Rate and Bonus Threshold"
      tooltip="Production models vary, please select the appropriate methodology based on your contract.">
      <p class="contract-score__label--block">What is your Production Bonus?</p>

      <lib-radios
        [formControlProperty]="bonusType"
        [radioInputs]="[
          {
            label: 'Work RVU',
            value: 'Wrvu',
            id: 'Wrvu',
            name: 'bonusType',
            tooltip: 'WRVU\'s are determined by methodology used by the Centers for Medicare &amp; Medicaid Services (CMS) and private payers to determine physician payment.'
          },
          {
            label: 'Total Collections',
            value: 'Collections',
            id: 'Collections',
            name: 'bonusType',
            tooltip: 'The actual cash collections for physician services.'
          }
        ]"
      ></lib-radios>

      <lib-scorecard-field 
        [trackingIdPrefix]="trackingIdPrefix" 
        trackingIdPostfix="Rating" 
        name="bonusRate"
        [labelText]="bonusType.value === BonusTypes.Wrvu ? '$/wRVU' : 'Production Bonus Ratio'" 
        [prefix]="bonusType.value === BonusTypes.Wrvu ? '$' : ''"
        [postfix]="bonusType.value === BonusTypes.Collections ? '%' : ''" 
        [maxLength]="bonusType.value === BonusTypes.Wrvu ? 11 : 5" 
        [decimalPoints]="2"
        [isBold]="true"
        [additionalValues]="{
                  'bonusType': bonusType.value
                }" 
        (submitEvent)="calculate($event)">
      </lib-scorecard-field>
      <lib-alert *ngIf="errors.has('bonusRate')" [centerContent]="true" [show]="true" [dismissible]="false" type="warning">
        <ng-content select="[data-slide-error='Bonus Rate']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('bonusRate')" [rating]="ratings.get('bonusRate')"></lib-scorecard-rating>

      <lib-scorecard-field 
        *ngIf="!!bonusType.value" 
        [trackingIdPrefix]="trackingIdPrefix" 
        trackingIdPostfix="Rating" name="bonusThreshold"
        [labelText]="bonusType.value === BonusTypes.Wrvu ? 'wRVU Threshold' : 'Collections Threshold'" 
        [prefix]="bonusType.value === BonusTypes.Wrvu ? '' : '$'"
        [maxLength]="11" 
        [decimalPoints]="2"
        [isBold]="true"
        [additionalValues]="{
                  'bonusType': bonusType.value
                }" 
        (submitEvent)="calculate($event)">
      </lib-scorecard-field>
      <lib-alert *ngIf="errors.has('bonusThreshold')" [centerContent]="true" [show]="true" [dismissible]="false" type="warning">
        <ng-content select="[data-slide-error='Bonus Threshold']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('bonusThreshold')" [rating]="ratings.get('bonusThreshold')"></lib-scorecard-rating>
    </lib-scorecard-section>

    <lib-scorecard-section class="slide" *libCarouselItem heading="Relocation Bonus"
      tooltip="Any amounts provided for purposes of relocation or moving in your contract.">
      <lib-scorecard-field [trackingIdPrefix]="trackingIdPrefix" trackingIdPostfix="Rating" prefix="$" name="relocationBonus"
        [maxLength]="6" labelText="Enter your relocation bonus:" (submitEvent)="calculate($event)">
      </lib-scorecard-field>
      <lib-alert *ngIf="errors.has('relocationBonus')" [centerContent]="true" [show]="true" [dismissible]="false"
        type="warning">
        <ng-content select="[data-slide-error='Relocation Bonus']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('relocationBonus')" [rating]="ratings.get('relocationBonus')"></lib-scorecard-rating>
    </lib-scorecard-section>

    <lib-scorecard-section class="slide" *libCarouselItem heading="Tail Coverage" tooltip="Tail coverage is the insurance needed to cover a physician for patient claims
                that may come in after the employment relationship has ended. If you have an
                occurrence-based policy - tail is not required and you should check Employer Paid.">
      <p class="contract-score__label--block">What is your Tail Coverage?</p>

      <lib-radios
        [formControlProperty]="tailCoverageType"
        [radioInputs]="[
          {
            label: 'Employee Paid',
            value: 'EmployeePaid',
            id: 'EmployeePaid',
            name: 'tailCoverageType'
          },
          {
            label: 'Shared Cost',
            value: 'SharedCost',
            id: 'SharedCost',
            name: 'tailCoverageType'
          },
          {
            label: 'Employer Paid',
            value: 'EmployerPaid',
            id: 'EmployerPaid',
            name: 'tailCoverageType'
          }
        ]"
        (selectedOption)="changeRadios($event)"
      ></lib-radios>

      <lib-alert *ngIf="errors.has('tailCoverageType')" [centerContent]="true" [show]="true" [dismissible]="false"
        type="warning">
        <ng-content select="[data-slide-error='Tail Coverage']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('tailCoverageType')" [rating]="ratings.get('tailCoverageType')"></lib-scorecard-rating>
    </lib-scorecard-section>

    <lib-scorecard-section class="slide" *libCarouselItem heading="Non-Compete Time Period and Distance"
      tooltip="A non-compete is sometimes referred to as a restrictive covenant. Not all non-competes will base their geographic restrictions in miles, please estimate to the best of your ability if your contract does not calculate this in miles.">
      <lib-scorecard-field [trackingIdPrefix]="trackingIdPrefix" trackingIdPostfix="Rating" postfix="Months" name="nonCompeteTimePeriod"
        [maxLength]="2" [isBold]="true" labelText="Time Period:"
        (submitEvent)="calculate($event)"></lib-scorecard-field>
      <lib-alert *ngIf="errors.has('nonCompeteTimePeriod')" [centerContent]="true" [show]="true" [dismissible]="false"
        type="warning">
        <ng-content select="[data-slide-error='Non-Compete Time Period']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('nonCompeteTimePeriod')" [rating]="ratings.get('nonCompeteTimePeriod')">
      </lib-scorecard-rating>

      <p class="slide__label">Distance:</p>
      <label class="contract-score__label">What is the size of the city?</label>

      <lib-radios
        [block]="true"
        [formControlProperty]="citySizeType"
        [radioInputs]="[
          {
            label: 'Small (0 - 250,000)',
            value: 'Small',
            id: 'contract-score-distance-small',
            name: 'citySizeType'
          },
          {
            label: 'Medium (250,000 - 5 Million)',
            value: 'Medium',
            id: 'contract-score-distance-medium',
            name: 'citySizeType'
          },
          {
            label: 'Large (5 Million+)',
            value: 'Large',
            id: 'contract-score-distance-large',
            name: 'citySizeType'
          }
        ]"
      ></lib-radios>

      <ng-container *ngIf="!!citySizeType.value">
        <lib-scorecard-field [trackingIdPrefix]="trackingIdPrefix" trackingIdPostfix="Rating" postfix="Miles" name="milesFromEmployer"
          labelText="How many miles from Employer?" [maxLength]="5" [decimalPoints]="2" [additionalValues]="{
              'citySizeType': citySizeType.value
            }" (submitEvent)="calculate($event)">
        </lib-scorecard-field>
        <lib-alert *ngIf="errors.has('milesFromEmployer')" [centerContent]="true" [show]="true" [dismissible]="false"
          type="warning">
          <ng-content select="[data-slide-error='Non-Compete Distance']"></ng-content>
        </lib-alert>
        <lib-scorecard-rating *ngIf="ratings.has('milesFromEmployer')" [rating]="ratings.get('milesFromEmployer')">
        </lib-scorecard-rating>
      </ng-container>
    </lib-scorecard-section>

    <lib-scorecard-section class="slide" *libCarouselItem heading="Paid Time Off"
      tooltip="Paid time off includes all vacation, sick and holiday time. CME is not included and should be entered in the next section.">
      <lib-scorecard-field [trackingIdPrefix]="trackingIdPrefix" trackingIdPostfix="Rating" name="ptoWeeks" postfix="Weeks"
        labelText="How many PTO weeks do you get?" [maxLength]="4" [decimalPoints]="2"
        (submitEvent)="calculate($event)"></lib-scorecard-field>
      <lib-alert *ngIf="errors.has('ptoWeeks')" [centerContent]="true" [show]="true" [dismissible]="false"
        type="warning">
        <ng-content select="[data-slide-error='Paid Time Off']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('ptoWeeks')" [rating]="ratings.get('ptoWeeks')"></lib-scorecard-rating>
    </lib-scorecard-section>

    <lib-scorecard-section class="slide" *libCarouselItem heading="Continuing Medical Education Time and Allowance"
      tooltip="Paid time you receive for continuing medical education and reimbursement for those conferences and classes should be entered here.">
      <lib-scorecard-field [trackingIdPrefix]="trackingIdPrefix" trackingIdPostfix="Rating" name="cmeWeeks" postfix="Weeks"
        labelText="Time:" [isBold]="true" [maxLength]="4" [decimalPoints]="2"
        (submitEvent)="calculate($event)"></lib-scorecard-field>
      <lib-alert *ngIf="errors.has('cmeWeeks')" [centerContent]="true" [show]="true" [dismissible]="false" type="warning">
        <ng-content select="[data-slide-error='Continuing Medical Education Time']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('cmeWeeks')" [rating]="ratings.get('cmeWeeks')"></lib-scorecard-rating>

      <lib-scorecard-field [trackingIdPrefix]="trackingIdPrefix" trackingIdPostfix="Rating" name="cmeAllowance" prefix="$"
        labelText="Allowance:" [isBold]="true" [maxLength]="6"
        (submitEvent)="calculate($event)"></lib-scorecard-field>
      <lib-alert *ngIf="errors.has('cmeAllowance')" [centerContent]="true" [show]="true" [dismissible]="false" type="warning">
        <ng-content select="[data-slide-error='Continuing Medical Education Allowance']"></ng-content>
      </lib-alert>
      <lib-scorecard-rating *ngIf="ratings.has('cmeAllowance')" [rating]="ratings.get('cmeAllowance')"></lib-scorecard-rating>
    </lib-scorecard-section>
  </lib-carousel>
</div>
